module.exports = __webpack_public_path__ + "img/sv95.1222f5fc.svg";